import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { Button, Form, Input } from 'antd'

const { TextArea } = Input

const NumericInput = (props) => {
  const { onChange } = props;

  const handleChange = (e) => {
    const { value: inputValue } = e.target;
    let phone = inputValue.replace(/[^\d]/g, "").substring(0, 10)
    if (phone.length === 1) {
      phone = phone.replace(/(\d{1})/, "($1")
    } else if (phone.length === 2) {
      phone = phone.replace(/(\d{2})/, "($1")
    } else if (phone.length === 3) {
      phone = phone.replace(/(\d{3})/, "($1)")
    } else if (phone.length === 4) {
      phone = phone.replace(/(\d{3})(\d{1})/, "($1) $2")
    } else if (phone.length === 5) {
      phone = phone.replace(/(\d{3})(\d{2})/, "($1) $2")
    } else if (phone.length === 6) {
      phone = phone.replace(/(\d{3})(\d{3})/, "($1) $2")
    } else if (phone.length === 7) {
      phone = phone.replace(/(\d{3})(\d{3})(\d{1})/, "($1) $2-$3")
    } else if (phone.length === 8) {
      phone = phone.replace(/(\d{3})(\d{3})(\d{2})/, "($1) $2-$3")
    } else if (phone.length === 9) {
      phone = phone.replace(/(\d{3})(\d{3})(\d{3})/, "($1) $2-$3")
    } else if (phone.length >= 10) {
      phone = phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")
    }
    onChange(phone)
  };

  return (
    <Input
      {...props}
      onChange={handleChange}
      placeholder="Enter the phone number"
      maxLength={14}
    />
  );
};

const ContactForm = ({
  visible,
  onCancel,
  websiteBackgroundColor,
  business,
  businessName,
  setShow,
}) => {

  const [value, setValue] = useState('');

  const onFinish = (values) => {
    // const { name, email, phone, message } = values
    const apiCall = `${process.env.REACT_APP_API_URL}/website-manager/contact-us/${business}`
    fetch(apiCall, {
      method: 'POST',
      body: JSON.stringify(values), // string or object
      headers: {
        'Content-Type': 'application/json'
      }
    })
    setShow(true)
    onCancel()
    // console.log('response', response)
  }


  return (
    <Modal show={visible} onHide={onCancel} aria-labelledby="contained-modal-title-vcenter" size="xs" centered>
      <Modal.Header closeButton style={{ backgroundColor: websiteBackgroundColor }}>
        <Modal.Title><span className="custom-font-style">Contact Us</span></Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: websiteBackgroundColor, padding: 24, fontSize: 14, lineHeight: 1.5715, wordWrap: 'break-word' }}>
        <Form
          // form={form}
          className="input-form-container coupon"
          layout="vertical"
          requiredMark="optional"
          onFinish={onFinish}
        >
          <div className="row coupon-form-block">
            <div className="col-12" style={{ paddingBottom: 20 }}>
              <Form.Item
                name="name"
                label="Name"
                rules={[
                  { required: true, message: "Please enter your name" },
                ]}
              >
                <Input
                  size="large"
                  placeholder="Enter your name"
                  maxLength={120}
                />
              </Form.Item>
            </div>
            <div className="col-12" style={{ paddingBottom: 20 }}>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  { required: true, message: "Please enter your email address" },
                  { type: 'email', message: "Please enter a valid email address" },
                  { max: 64, message: "Email address must be up to 64 characters" },
                ]}
              >
                <Input
                  size="large"
                  placeholder="Enter your email address"
                  maxLength={64}
                />
              </Form.Item>
            </div>
            <div className="col-12" style={{ paddingBottom: 20 }}>
              <Form.Item
                name="phone"
                label="Phone Number"
                rules={[{ required: true, message: "Please enter your phone number" }]}
              >
                <NumericInput value={value} onChange={setValue} />
              </Form.Item>
            </div>
            <div className="col-12" style={{ paddingBottom: 20 }}>
              <Form.Item
                name="message"
                label="Message"
                rules={[
                  { required: true, message: "Please enter your message" },
                ]}
              >
                <TextArea
                  placeholder="Enter your message"
                  style={{ resize: 'none', maxWidth: '500px', height: '100px' }}
                  maxLength="600"
                />
              </Form.Item>
            </div>
          </div>
          <div className="form-footer" style={{ textAlign: 'right' }}>
            <Form.Item className="center-align">
              <Button className="btn-header btn-brand btn-footer" type="primary" htmlType="submit" size="large">
                Send
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  )
}

export default ContactForm
